import dynamic from "next/dynamic";
import { useController, useFormContext } from "react-hook-form";
import InputWrapper from "../InputWrapper/InputWrapper";
import styles from "./DateComponent.module.scss";
const DatePicker = dynamic(
  () => import("components/inputs/DatePicker/DatePicker")
);

// Only for use with react-hook-form

export default function DateComponent({
  id,
  label,
  register,
  control,
  formState,
  wrapperProps,
  mode,
  attributes,
  useFormMethods,
  min,
  max,
  hidden,
  disabled,
  portalRef,
  floatingUiProps,
  onClear = () => {},
}) {
  const { setError, clearErrors, errors, watch, setValue, trigger } =
    useFormContext();

  const { field } = useController({
    name: id,
    control,
  });

  let fieldOnBlur = field?.onBlur ?? (() => {});
  let fieldOnChange = field?.onChange ?? (() => {});

  return (
    <InputWrapper label={label} id={id} formState={formState} {...wrapperProps}>
      {/* <input {...register(id)} type="date" className={`${styles.date}`} /> */}
      <div className={`${styles.datePickerContainer}`}>
        <DatePicker
          name={id}
          inputHandler={(id, input) => {
            fieldOnChange(input);
          }}
          register={register}
          initialDate={field?.value ?? "None"}
          portalRef={portalRef}
          floatingUiProps={floatingUiProps}
          mode={mode}
          min={min}
          max={max}
          hidden={hidden}
          disabled={disabled}
          onClear={() => {
            onClear();
            clearErrors(id);
          }}
          onBlur={async (date) => {
            if (date === "None") {
              clearErrors(id);
            }
            fieldOnBlur();
          }}
          onChange={async (date) => {
            // if (
            //   new Date(date) >= new Date().setHours(0, 0, 0, 0) ||
            //   date === "None"
            // ) {
            //   clearErrors(id);
            // } else {
            //   setError(id, {
            //     message: "Date must be in the future",
            //     type: "DateError",
            //   });
            // }
            fieldOnChange(date);
          }}
        />
      </div>
    </InputWrapper>
  );
}
